import { Component, EventListener, GondelBaseComponent } from '@gondel/core';
import { isInViewport } from '../../../../shared/utils/js/is-in-viewport';

/**
 * video-teaser module implementation.
 * @author Danijel Malinovic <danijel.malinovic@merkleinc.com>
 */

enum Selectors {
	PlayButton = '.js-video-teaser__button-play',
	VideoCover = '.m-video-teaser__cover',
	VideoWrapper = '.m-video-teaser__video',
	IFrame = '.js-video-teaser__video-iframe',
	InternalVideo = '.js-video-teaser__video-internal',
}

enum States {
	CoverOpen = 'state-m-video-teaser__cover--open',
	VideoOpen = 'state-m-video-teaser-video--open',
}

enum CustomDataAttributes {
	Autoplay = 'data-autoplay',
	External = 'data-external',
}

@Component('VideoTeaser')
export class VideoTeaser extends GondelBaseComponent {
	private _windowEvents = ['DOMContentLoaded', 'load', 'scroll', 'resize'];
	private readonly _requiredCookieCategory: string = 'C0004';

	public start() {
		if (this._checkBooleanAttribute(CustomDataAttributes.Autoplay)) {
			this._windowEvents.forEach((windowEvent) => {
				window.addEventListener(windowEvent, () => this._checkIfVideoIsInViewport(this._ctx));
			});
		}
	}

	public stop() {
		if (this._checkBooleanAttribute(CustomDataAttributes.Autoplay)) {
			this._windowEvents.forEach((windowEvent) => {
				window.removeEventListener(windowEvent, () => this._checkIfVideoIsInViewport(this._ctx));
			});
		}
	}

	 
	@EventListener('click', Selectors.PlayButton)
	private _swapContainers() {
		const videoCover = this._ctx.querySelector(Selectors.VideoCover);
		const videoWrapper = this._ctx.querySelector(Selectors.VideoWrapper);

		videoCover?.classList.remove(States.CoverOpen);
		videoWrapper?.classList.add(States.VideoOpen);

		this._startVideo();
	}

	private _startVideo() {
		if (this._checkBooleanAttribute(CustomDataAttributes.External)) {
			this._startIFrameVideo();
		} else {
			this._startInternalVideo();
		}
	}

	private _startIFrameVideo() {
		if (this._checkCookieCategory()) {
			const iFrame = this._ctx.querySelector(Selectors.IFrame);
			const src: string = iFrame?.getAttribute('data-srcset') ?? '';
			if (!src.includes('autoplay=1')) {
				iFrame?.setAttribute('src', src.concat('&autoplay=1'));
			}
		}
	}

	private _checkCookieCategory(): boolean {
		if ((window as any).Optanon) {
			const allowedCookies = (window as any).OptanonActiveGroups || '';
			return allowedCookies.includes(this._requiredCookieCategory);
		}

		return true;
	}

	private _startInternalVideo() {
		const video = this._ctx.querySelector(Selectors.InternalVideo) as HTMLVideoElement;
		video?.play();
	}

	private _checkIfVideoIsInViewport(_ctx) {
		if (isInViewport(_ctx)) {
			this._startVideo();
		}
	}

	private _checkBooleanAttribute(attributeName: CustomDataAttributes) {
		const attr = this._ctx.getAttribute(attributeName);

		if (attr) {
			return JSON.parse(attr) as boolean;
		}

		return false;
	}
}
